@if (!viewOnly) {
  <div class="file-upload mb-2" [formGroup]="fGroup">
    @if (!isFileSelected) {
      <div class="file-not-selected">
        <div class="file-upload-layout">
          <div class="align-left">
            <i class="far fa-file-upload fa-2x"></i>
          </div>
          <div class="align-left">
            <div class="file-description">
              <ng-container>No File Uploaded</ng-container>
            </div>
          </div>
          <div class="align-right">
            <button type="button" class="btn" (click)="fileInput.click()">
              <i class="fal fa-file-upload" style="display: inline;"></i>
              &nbsp;
              <span>Upload</span>
            </button>
          </div>
        </div>
      </div>
    }
    @if (isFileSelected) {
      <div class="file-selected">
        <div class="file-upload-layout">
          <div class="align-left">
            @if (selectedFileName && !hasFileChanged) {
              <i class="far fa-file-check fa-2x"></i>
            }
            @if (hasFileChanged) {
              <i class="far fa-file-upload fa-2x"></i>
            }
          </div>
          <div class="align-left">
            @if (selectedFileName && !hasFileChanged) {
              <div class="file-description">On File</div>
              <div class="file-name">
                @if (canDownload) {
                  <a href="javascript:void(0);" [title]="'Download ' + selectedFileName"
                    (click)="onDownload.emit()">
                    {{selectedFileName}}
                  </a>
                }
                @if (!canDownload) {
                  {{selectedFileName}}
                }
              </div>
            }
            @if (hasFileChanged) {
              <div class="file-description">
                @if (!selectedFile) {
                  No File Selected
                }
                @if (selectedFile) {
                  File To Upload
                }
              </div>
              @if (selectedFile) {
                <div class="file-name">
                  <span class="selected-file">{{selectedFile.name}}</span>
                </div>
              }
            }
          </div>
          <div class="align-right">
            <div class="">
              <button type="button" class="btn " (click)="fileInput.click()">
                <i class="fal fa-pencil" style="display: inline;"></i>
                &nbsp;
                <span>Change</span>
              </button>
            </div>
            @if (canRemoveFile) {
              <div class="mt-2">
                <button type="button" class="btn " (click)="removeFile()">
                  <i class="fal fa-pencil" style="display: inline;"></i>
                  &nbsp;
                  <span>Remove</span>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <input #fileInput type="file" [hidden]="true" [id]="fieldID" [name]="fieldName" [accept]="acceptType"
      [formControlName]="fControlName" [attr.aria-required]="required" [attr.aria-invalid]="invalid"
      (change)="fileChanged($event)">
  </div>
}
@if (viewOnly) {
  <div class="file-upload">
    @if (!isFileSelected) {
      <div class="file-not-selected">
        <i class="far fa-file-upload fa-2x"></i>
        <div class="file-description">
          <ng-container>No File Uploaded</ng-container>
        </div>
      </div>
    }
    @if (isFileSelected) {
      <div class="file-selected">
        @if (selectedFileName && !hasFileChanged) {
          <i class="far fa-file-check fa-2x"></i>
        }
        @if (hasFileChanged) {
          <i class="far fa-file-upload fa-2x"></i>
        }
        @if (selectedFileName && !hasFileChanged) {
          <div class="file-description">On File</div>
          <div class="file-name">
            @if (canDownload) {
              <a href="javascript:void(0);" [title]="'Download ' + selectedFileName"
                (click)="onDownload.emit()">
                {{selectedFileName}}
              </a>
            }
            @if (!canDownload) {
              {{selectedFileName}}
            }
          </div>
        }
        @if (hasFileChanged) {
          <div class="file-description">
            @if (!selectedFile) {
              No File Selected
            }
            @if (selectedFile) {
              File To Upload
            }
          </div>
          @if (selectedFile) {
            <div class="file-name">
              <span class="selected-file">{{selectedFile.name}}</span>
            </div>
          }
        }
      </div>
    }
  </div>
}